<template>
  <section>
    <div class="tx-16 font-weight-bold">Миний профайл</div>
    <div class="tx-14 text-muted">{{ $store.state.user.userInfo.depart }}</div>
    <div class="text-center mg-y-30 ">
      <vc-donut
        :sections="[
          {
            value:
              mustJoinCourses.all > 0
                ? (mustJoinCourses.finished * 100) / mustJoinCourses.all
                : 0,
            color: '#2856a8',
          },
        ]"
        class="avator-bg"
        :style="`background-image:url('${myResBaseUrl}v4-assets/bg2.png')`"
        background="#fafafa"
        foreground="#fff"
        :size="125"
        unit="px"
        :thickness="4"
        :total="100"
        :start-angle="-30"
        :auto-adjust-text-size="true"
      >
        <div class=" mg-y-20">
          <img
            :src="`${$store.state.user.userInfo.avator}`"
            class="rounded-circle wd-100 ht-100"
          />
        </div>
      </vc-donut>
      <div class="pd-t-20 tx-16 font-weight-bold">
        {{ $store.state.user.userInfo.ovog }}
        {{ $store.state.user.userInfo.ner }}
      </div>
      <div class="tx-14 text-muted">
        {{ $store.state.user.userInfo.position }}
      </div>
    </div>
    
    
  </section>
</template>
<script>


export default {
  props: {
    mustJoinCourses: {
      type: Object,
      default: () => {},
    },
  },
  data() {
    return {
      myResBaseUrl: "https://res.gosmart.mn/",
      
    };
  },
  created() {
    if (
      this.$store.state.app.activeGroup.resBaseUrl != undefined &&
      this.$store.state.app.activeGroup.resBaseUrl != ""
    ) {
      this.myResBaseUrl = this.$store.state.app.activeGroup.resBaseUrl;
    }
  },
  methods: {
    // getConfigValueByKey(key) {
    //   return getConfigValueByKey(this.$store.state.app.groupSettings, key);
    // },
  },
  mounted() {
    // let _learnExamRegistration = this.getConfigValueByKey(
    //   "learnExamRegistration"
    // );
    // if (this.$store.state.app.activeGroup.id == 6126) {
    //   if (this.$store.state.user.userInfo.locType4Code != "member") {
    //     this.learnExamRegistration = parseInt(_learnExamRegistration, 10);
    //   }
    // } else {
    //   this.learnExamRegistration = parseInt(_learnExamRegistration, 10);
    // }
  },
};
</script>
<style scoped lang="less">
.avator-bg {
  background-repeat: no-repeat;
  background-position: center;
}
</style>
